import { useState } from "react";
import { Box, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import UserInfo from "./components/UserInfo";
import DashboardDinamicoRecambista from "../shared/components/DashboardDinamicoRecambista";

export default function Account() {
    const user = JSON.parse(localStorage.getItem('user'));
    const [tab, setTab] = useState('current-fact');

    const handleChangeTab = (e, tab) => setTab(tab);
  
    return (
        <div className="content ajustes">
            <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChangeTab} aria-label="Mi Cuenta">
                    { user.rol_id === 2 && <Tab label="Dashboard dinámico" value="dashboard" /> }
                    { user.rol_id === 2 && <Tab label="Mi facturación" value="current-fact" /> }
                </TabList>
                </Box>
                <TabPanel value="dashboard">
                    <DashboardDinamicoRecambista />
                </TabPanel>
                <TabPanel value="current-fact">
                    <UserInfo />
                </TabPanel>
            </TabContext>
        </div>
    )
}